import { http } from 'utils'

// Application mutation imports.
import { APP_LOADING, SET_NAVIGATION_COUNTS } from 'vx/mutations'

// Application state.
const state = {
  loading: false,
  navigationCounts: {}
}

// Application state getters.
const getters = {
  notLoading: state => state.loading === false
}

// Application actions.
const actions = {
  /**
   * Get the navigation counts.
   */
  getNavigationCounts ({ commit }) {
    return http.get('navigation').then(response => {
      commit(SET_NAVIGATION_COUNTS, response.data)

      return response
    })
  }
}

// Application state mutations.
const mutations = {
  /**
   * Set the application loading flag.
   *
   * @return void
   */
  [APP_LOADING] (state, loading) {
    state.loading = loading
  },

  /**
   * Set the navigation counts.
   */
  [SET_NAVIGATION_COUNTS] (state, counts) {
    state.navigationCounts = counts
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js